import { Bootstrap } from "./bootstrap";

require("../css/index.css");

Bootstrap.mount();

